/* eslint-disable i18next/no-literal-string */
import {Box, Divider, Heading, Link, Text, VStack} from '@chakra-ui/react';

export const MentionsLegales: React.FC = () => {
  return (
    <Box
      p={5}
      borderWidth='1px'
      borderRadius='lg'
      overflow='hidden'
    >
      <VStack
        spacing={4}
        align='stretch'
      >
        <Heading size='lg'>Mentions légales</Heading>
        <Text>En vigueur au 04/12/2023</Text>
        <Text>
          Conformément aux dispositions des Articles 6-III et 19 de la Loi
          n°2004-575 du 21 juin 2004 pour la Confiance dans l’économie
          numérique, dite L.C.E.N., il est porté à la connaissance des
          utilisateurs et visiteurs, ci-après l’&quot;Utilisateur&quot;, du site
          ffconnect.france-frais.fr, ci-après le &quot;Site&quot;, les présentes
          mentions légales.
        </Text>
        <Text>
          La connexion et la navigation sur le Site par l’Utilisateur implique
          acceptation intégrale et sans réserve des présentes mentions légales.
          Ces dernières sont accessibles sur le Site à la rubrique « Mentions
          légales ».
        </Text>
        <Divider />
        <Heading size='md'>ARTICLE 1 - L’EDITEUR</Heading>
        <Text>L’édition du Site est assurée par SYNAKO.</Text>
        <Text>
          Numéro de téléphone: 0614815553, Adresse e-mail: hello@synako.fr.
        </Text>
        <Text>N° de TVA intracommunautaire: FR86910394139</Text>
        <Text>Le Directeur de la publication est Olaf BURKI</Text>
        <Divider />
        <Heading size='md'>ARTICLE 2 - L’HEBERGEUR</Heading>
        <Text>
          Le site est hébergé par Google Cloud Platform – Google France, 8 rue
          de Londres, 75 009 Paris – France.
        </Text>
        <Divider />
        <Heading size='md'>ARTICLE 3 - ACCES AU SITE</Heading>
        <Text>
          Le Site est accessible en tout endroit, 7j/7, 24h/24 sauf cas de force
          majeure, interruption programmée ou non et pouvant découler d’une
          nécessité de maintenance.
        </Text>
        <Text>
          En cas de modification, interruption ou suspension du Site, l’Editeur
          ne saurait être tenu responsable.
        </Text>
        <Divider />
        <Heading size='md'>ARTICLE 4 - COLLECTE DES DONNEES</Heading>
        <Text>
          Le Site assure à l’Utilisateur une collecte et un traitement
          d’informations personnelles dans le respect de la vie privée
          conformément à la loi n°78-17 du 6 janvier 1978 relative à
          l’informatique, aux fichiers et aux libertés.
        </Text>
        <Text>
          En vertu de la loi Informatique et Libertés, en date du 6 janvier
          1978, l’Utilisateur dispose d’un droit d’accès, de rectification, de
          suppression et d’opposition de ses données personnelles. L’Utilisateur
          exerce ce droit par mail à l’adresse email contact@france-frais.fr.
        </Text>
        <Text>
          Toute utilisation, reproduction, diffusion, commercialisation,
          modification de toute ou partie du Site, sans autorisation de
          l’Editeur est prohibée et pourra entraîner des actions et poursuites
          judiciaires telles que notamment prévues par le Code de la propriété
          intellectuelle et le Code civil.
        </Text>
        <Divider />
        <Text>CONCEPTION ET RÉALISATION</Text>
        <Text>
          <Link
            href='https://www.synako.fr'
            isExternal
            color='teal.500'
          >
            Synako
          </Link>{' '}
          / 6 RUE PHILIPPE DE METZ 92270 BOIS-COLOMBES
        </Text>
        <Text>
          <Link
            href='https://www.nordsud.io/'
            isExternal
            color='teal.500'
          >
            NordSud
          </Link>{' '}
          / 68 rue Réné Boulanger, 75010 Paris
        </Text>
      </VStack>
    </Box>
  );
};
